module.exports = __webpack_public_path__ + "img/103.6210301a.png";